import { FileText, Mail } from "lucide-react";

const SUPPORT_EMAIL = "support@scudononni.it";

export default function Termini() {
  return (
    <div data-testid="termini-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="text-center mb-12 animate-fade-up">
        <FileText size={56} className="mx-auto text-[#1E3A8A] mb-5" />
        <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-[#1E3A8A] leading-tight">
          Termini di Servizio
        </h1>
        <p className="mt-2 text-base text-gray-500">Ultimo aggiornamento: 27 febbraio 2026</p>
      </div>

      <div className="bg-white rounded-[2rem] shadow-lg border-4 border-blue-50 p-6 md:p-12 space-y-8 text-lg md:text-xl text-gray-700 leading-relaxed">
        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">1. Oggetto</h2>
          <p>
            Questi Termini regolano l'utilizzo del sito{" "}
            <a href="https://scudononni.it" className="text-[#1E3A8A] font-bold underline">www.scudononni.it</a>{" "}
            ("Servizio"), che offre l'analisi automatica di messaggi sospetti (email, SMS, WhatsApp, ecc.)
            per aiutare le persone anziane a riconoscere possibili truffe online.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">2. Servizio gratuito</h2>
          <p>
            Il Servizio è offerto <strong>gratuitamente</strong>, senza necessità di registrazione.
            Per garantire la sostenibilità è previsto un limite di <strong>3 verifiche al giorno</strong>{" "}
            per dispositivo e per indirizzo IP.
          </p>
        </section>

        <section className="bg-[#FEF3C7] border-4 border-[#D97706] rounded-2xl p-6">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#78350F] mb-3">3. Avvertenza importante — Non è un parere legale</h2>
          <p className="text-[#78350F]">
            Il risultato fornito da ScudoNonni è generato da un sistema di <strong>intelligenza artificiale</strong>{" "}
            (Google Gemini 3) e costituisce un <strong>orientamento</strong>, non una certezza assoluta.
            Ai sensi del Regolamento UE 2024/1689 (<strong>EU AI Act</strong>) — applicabile dal 2 agosto 2026,
            in particolare l'art. 50 sugli obblighi di trasparenza — ti informiamo apertamente di questa circostanza
            ogni volta che ricevi una risposta. ScudoNonni <strong>non sostituisce</strong> il parere di un esperto
            di sicurezza informatica, di un avvocato, della banca o delle forze dell'ordine.{" "}
            <strong>Nel dubbio chiama sempre un familiare di fiducia o la Polizia Postale al 06 4654 1.</strong>
          </p>
          <p className="mt-3 text-[#78350F]">
            Non rispondiamo per eventuali danni derivanti da un'errata interpretazione del risultato.
            Per i dettagli completi sull'uso dell'IA leggi la pagina <a href="/trasparenza-ai" className="font-bold underline">Trasparenza AI</a>.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">4. Uso corretto</h2>
          <p className="mb-3">Utilizzando ScudoNonni ti impegni a:</p>
          <ul className="list-disc pl-8 space-y-2">
            <li>Inviare solo messaggi ricevuti realmente, per finalità personali e di sicurezza.</li>
            <li>Non inviare contenuti illegali, offensivi, pornografici, violenti o protetti da copyright altrui.</li>
            <li>Non utilizzare il Servizio per attività automatizzate massive (bot, scraping) o per aggirare il limite giornaliero.</li>
            <li>Non tentare di compromettere il funzionamento del sito o la sicurezza dei dati.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">5. Proprietà intellettuale</h2>
          <p>
            Il nome ScudoNonni, il logo e i contenuti del sito sono protetti dalle leggi sul diritto d'autore
            e sui marchi. I contenuti possono essere condivisi liberamente per scopi informativi e non commerciali,
            citando la fonte.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">6. Limitazione di responsabilità</h2>
          <p>
            Il Servizio è fornito "così com'è", senza garanzie di disponibilità ininterrotta o di accuratezza
            assoluta del risultato. Nei limiti consentiti dalla legge, ScudoNonni non è responsabile per danni
            diretti o indiretti derivanti dall'uso del Servizio.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">7. Modifiche</h2>
          <p>
            Possiamo aggiornare questi Termini in qualsiasi momento. Le modifiche sono efficaci dalla pubblicazione
            sul sito.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-3">8. Legge applicabile e foro</h2>
          <p>
            Si applica la legge italiana. Per qualsiasi controversia sarà competente il foro del consumatore,
            ove applicabile, secondo la normativa vigente.
          </p>
        </section>

        <section className="bg-[#DBEAFE] rounded-2xl p-6">
          <h2 className="font-heading text-2xl font-bold text-[#1E3A8A] mb-3 flex items-center gap-3">
            <Mail size={28} /> Contattaci
          </h2>
          <p>
            Per informazioni sui Termini:{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[#1E3A8A] font-bold underline">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
